export default "__VITE_ASSET__CG47htFl__"